import { ReactNode } from 'react';

export const TableCellCategory = ({
  text,
  subText,
}: {
  text: string | ReactNode;
  subText: string | ReactNode;
}) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          fontSize: 36,
          margin: 0,
          display: 'flex',
          alignItems: 'center',
          lineHeight: '1em',
        }}
      >
        {text}
      </div>
      <p
        style={{
          fontSize: 18,
          margin: 0,
          marginLeft: 8,
          fontWeight: 400,
          textAlign: 'left',
          fontFamily: 'Merriweather',
          color: '#000',
        }}
      >
        {subText}
      </p>
    </div>
  );
};
